module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "15",
      "height": "14",
      "viewBox": "0 0 15 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.7194 11.3799H12.7587C12.6837 11.3799 12.6212 11.4424 12.6212 11.5174V12.621H1.37651V1.37455H12.6229V2.47813C12.6229 2.55313 12.6854 2.61563 12.7604 2.61563H13.7212C13.7962 2.61563 13.8587 2.55491 13.8587 2.47813V0.688839C13.8587 0.385268 13.614 0.140625 13.3104 0.140625H0.690793C0.387221 0.140625 0.142578 0.385268 0.142578 0.688839V13.3067C0.142578 13.6103 0.387221 13.8549 0.690793 13.8549H13.3087C13.6122 13.8549 13.8569 13.6103 13.8569 13.3067V11.5174C13.8569 11.4406 13.7944 11.3799 13.7194 11.3799ZM13.964 6.35491H8.35687V4.99777C8.35687 4.87813 8.21758 4.81027 8.12472 4.88527L5.59079 6.88527C5.57372 6.89863 5.55991 6.91571 5.55041 6.9352C5.54092 6.95469 5.53598 6.97609 5.53598 6.99777C5.53598 7.01945 5.54092 7.04085 5.55041 7.06034C5.55991 7.07983 5.57372 7.09691 5.59079 7.11027L8.12472 9.11027C8.21937 9.18527 8.35687 9.11741 8.35687 8.99777V7.64063H13.964C14.0426 7.64063 14.1069 7.57634 14.1069 7.49777V6.49777C14.1069 6.4192 14.0426 6.35491 13.964 6.35491Z",
      "fill": _vm.color ? _vm.color : 'black',
      "fill-opacity": "0.85"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f9aa6e9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9aa6e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/import.vue
// module id = 1502
// module chunks = 159